
































































import { Component, Watch, Vue, Prop } from 'vue-property-decorator'
import api from "../../api/index"
import Box from "../components/Box.vue"
import AvatarCropper from '../components/AvatarCropper.vue'
import { Action, Getter } from 'vuex-class'

@Component({
  components: {
    Box,
    AvatarCropper,
  },
})

export default class UserProfile extends Vue {
  image64 = ''
  crop = 1
  imageEdited = false

  loading = false
  userLoading = false

  emailApiError = false
  phoneApiError = false
  emailSubmitted = ""
  phoneSubmitted = ""

  profileWasSuccessfullyUpdated = false
  avatarUpdated = false
  avatarSent = false

  showProfileImage = true
  showProfileInfo = false
  isActiveColor = '#FF4545'
  isInactiveColor = ''

  unPrefixedPhone = ""

  @Getter('admin') admin:any

  @Prop({ default: false })
  isActive!: boolean

  @Prop({ default: false })
  user:any

  updated() {
    if (this.user.mobile_phone_number) {
      this.unPrefixedPhone = this.user.mobile_phone_number.substr(3)
    }
  }

  closeModal() {
    this.$emit('close')
    this.profileWasSuccessfullyUpdated = false
    this.avatarSent = false
    this.avatarUpdated = false
    this.emailApiError = false
    this.phoneApiError = false
    this.$emit('updated')
  }

  getAvatar(base64:any) {
    this.imageEdited = true
    this.image64 = base64
  }

  async updateUserProfileInfos() {
    this.crop++
    if (this.image64 && this.showProfileImage) {
      this.avatarSent = true
      try {
        if (this.admin) {
          const res = await api.put("bo/users/" + this.user.id + "/avatar", { 
            file: this.image64
          })
          this.user = res.data
        } else {
          const res = await api.put("bo/avatar", { 
            file: this.image64
          })
          this.user = res.data
        }
        this.emailApiError = false
        this.phoneApiError = false
        this.avatarUpdated = true
        this.$emit('updated')
        this.avatarSent = false
      } catch (e) {
        if (e.response.status !== 200) {
          console.log(e.response.status)
        }
      }
    }

    if(this.showProfileInfo) {
      try {
        if (this.admin) {
          const res = await api.put("bo/users/" + this.user.id, { 
            user: {
              mobile_phone_number: "+33" + this.unPrefixedPhone,
              email: this.user.email,
              gender: this.user.gender,
              first_name: this.user.first_name,
              last_name: this.user.last_name
            }
          })
          this.user = res.data
        } else {
          const res = await api.put("bo/registration", { 
            registration: {
              mobile_phone_number: "+33" + this.unPrefixedPhone,
              email: this.user.email,
              gender: this.user.gender,
              first_name: this.user.first_name,
              last_name: this.user.last_name
            }
          })
          this.user = res.data
        }
        this.emailApiError = false
        this.phoneApiError = false
        this.profileWasSuccessfullyUpdated = true
        this.$emit('updated')
      } catch (e) {
        if (e.response.status === 422) {
          if (e.response.data.errors[0] === "Mobile phone number n'est pas disponible") {
            this.phoneSubmitted = "+33" + this.unPrefixedPhone
            this.phoneApiError = true
          }
          if (e.response.data.errors[0] === "Email n'est pas disponible") {
            this.emailSubmitted = this.user.email
            this.emailApiError = true
          }
        }
      }
    }

    this.closeModal()
  }

  @Watch('isUserProfileModalActive')
  async deleteNotifications() {
    this.emailApiError = this.phoneApiError = this.profileWasSuccessfullyUpdated = false
    // await this.getUser()
  }

  goToProfileImage() {
    this.showProfileImage = true
    this.showProfileInfo = false
  }
  goToProfileInfo() {
    this.showProfileImage = false
    this.showProfileInfo = true
  }

  get formIsValid() {
    const emailIsValid = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.user.email)
    if (emailIsValid) {
      return true
    } else {
      return false
    }
  }
}
